<div class="basket-order-container" *ngIf="agreement()">
  <div class="basket-order" *ngIf="foods.length > 0 || drinks.length > 0">
    <div class="basket-order-swipe-area">
      <span class="swipe-circle" #swipeCircle>
        <svg xmlns="http://www.w3.org/2000/svg">
          <path class="arrow" fill-rule="evenodd"
            d="M12.551,8.707 L5.256,1.412 C4.270,0.426 2.672,0.426 1.686,1.412 C0.701,2.398 0.701,3.996 1.686,4.981 L7.197,10.492 L1.686,16.003 C0.701,16.988 0.701,18.587 1.686,19.572 C2.672,20.558 4.270,20.558 5.256,19.572 L12.551,12.276 C13.537,11.292 13.537,9.693 12.551,8.707 Z"
            transform="translate(5, 1)" />
        </svg>
      </span>
      <div class="basket-order-content" #swipeContent>
        <span class="basket-order-content-swipe" *ngIf="order && order.guests && order.guests[guestId]">
           {{ 'slideToAddToOrder' | translate }}
        </span>
        <span class="basket-order-content-swipe" *ngIf="order && order.guests && !order.guests[guestId] || !order">
          {{ 'swipeToPlaceYourOrder' | translate }}
        </span>
        <div class="basket-order-content-details">
          <div class="basket-order-content-price" *ngIf="total as value">
            <ng-container *ngIf="value | priceSeparator as separated">
              <span class="basket-order-content-price__whole">{{ separated.whole }}</span>
              <span class="basket-order-content-price__separator">{{ separated.separator }}</span>
              <span class="basket-order-content-price__fraction">{{ separated.fraction }}</span>
              <span class="basket-order-content-price__currency">{{ locale?.currency }}</span>
            </ng-container>
          </div>
          <div class="basket-order-content__items">
              <span *ngIf="foodsCount">
                {{ foodsCount }} {{ (foodsCount === 1 ? 'food' : 'foods') | translate }}
              </span>
              <span *ngIf="foodsCount && drinksCount">{{ 'and' | translate }}</span>
              <span *ngIf="drinksCount">
                {{ drinksCount }} {{ (drinksCount === 1 ? 'drink' : 'drinks') | translate }}
              </span>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>